import React from 'react';
import { Link } from 'react-router-dom';
import { MapPin, Phone, Mail, Facebook, Instagram } from 'lucide-react';

const Footer = () => {
  return (
    <footer className="bg-burgundy text-white">
      {/* Main Footer */}
      <div className="container mx-auto px-4 py-12">
        <div className="grid grid-cols-1 md:grid-cols-3 gap-12">
          {/* Brand */}
          <div>
            <h3 className="text-2xl font-bold mb-4">Volaille Prime</h3>
            <p className="text-gold text-sm mb-4">Goût. Fraîcheur. Confiance.</p>
            <p className="text-gray-300 text-sm leading-relaxed">
              Production locale de poulets de qualité à Thiès. 
              Nous nous engageons à fournir des produits frais et sûrs pour tous nos clients.
            </p>
          </div>

          {/* Contact */}
          <div>
            <h4 className="text-xl font-bold mb-4">Contact</h4>
            <div className="space-y-3 text-sm">
              <div className="space-y-2">
                <a 
                  href="https://wa.me/221781270846" 
                  target="_blank" 
                  rel="noopener noreferrer"
                  className="flex items-start gap-3 text-gray-300 hover:text-gold transition-colors"
                >
                  <Phone size={18} className="mt-0.5 flex-shrink-0" />
                  <span>+221 78 127 08 46</span>
                </a>
                <a 
                  href="tel:+221779093914"
                  className="flex items-start gap-3 text-gray-300 hover:text-gold transition-colors ml-6"
                >
                  <span>+221 77 909 39 14</span>
                </a>
              </div>
              <div className="flex items-start gap-3 text-gray-300">
                <MapPin size={18} className="mt-0.5 flex-shrink-0" />
                <span>Thiès, Sénégal</span>
              </div>
              <a 
                href="mailto:sales@volailleprime.com"
                className="flex items-start gap-3 text-gray-300 hover:text-gold transition-colors"
              >
                <Mail size={18} className="mt-0.5 flex-shrink-0" />
                <span>sales@volailleprime.com</span>
              </a>
            </div>
          </div>

          {/* Quick Links */}
          <div>
            <h4 className="text-xl font-bold mb-4">Liens rapides</h4>
            <div className="space-y-2 text-sm">
              <Link 
                to="/"
                className="block text-gray-300 hover:text-gold transition-colors"
              >
                Accueil
              </Link>
              <Link 
                to="/produits"
                className="block text-gray-300 hover:text-gold transition-colors"
              >
                Produits & Commande
              </Link>
              <Link 
                to="/a-propos"
                className="block text-gray-300 hover:text-gold transition-colors"
              >
                À propos
              </Link>
              <Link 
                to="/contact"
                className="block text-gray-300 hover:text-gold transition-colors"
              >
                Contact
              </Link>
            </div>

            {/* Social Media */}
            <div className="mt-6">
              <h5 className="text-sm font-semibold mb-3">Suivez-nous</h5>
              <div className="flex gap-4">
                <a 
                  href="#" 
                  className="w-10 h-10 bg-white/10 hover:bg-gold rounded-full flex items-center justify-center transition-all hover:scale-110"
                  aria-label="Facebook"
                >
                  <Facebook size={18} />
                </a>
                <a 
                  href="#" 
                  className="w-10 h-10 bg-white/10 hover:bg-gold rounded-full flex items-center justify-center transition-all hover:scale-110"
                  aria-label="Instagram"
                >
                  <Instagram size={18} />
                </a>
              </div>
            </div>
          </div>
        </div>
      </div>

      {/* Legal Footer */}
      <div className="border-t border-white/10">
        <div className="container mx-auto px-4 py-6">
          <div className="text-center text-sm text-gray-400">
            <p className="mb-2">
              <strong className="text-white">Volaille Prime</strong> est une marque de{' '}
              <strong className="text-gold">DMB Consulting</strong> – Entreprise Individuelle
            </p>
            <p className="text-xs">
              Tous les paiements sont encaissés par DMB Consulting
            </p>
            <p className="mt-4 text-xs">
              © {new Date().getFullYear()} Volaille Prime. Tous droits réservés.
            </p>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
